(function(){
  // ── Constantes editables ──
  var COMPANY_ID = 'QPR54y';
  var WA_NUMBER = '56933353225';   // número del bot de whatsapp (sin +, sin espacios)
  function ctaHref(label){
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent('hola, hice el diagnóstico de palancas de ndf growth y mi resultado fue: ' + label + '. quiero agendar mi diagnóstico');
  }
  var SHOW_VIDEO = false;
  var VIDEO_URL = '';

  var root = document.getElementById('ndf-dp');
  if (!root) return;

  var QUESTIONS = [
    { eje:'facturación', scored:false, q:'¿cuánto factura aproximadamente tu ecommerce al mes?', o:[
      'menos de $10 millones','entre $10 y $30 millones','entre $30 y $50 millones','entre $50 y $100 millones','más de $100 millones']},
    { eje:'prioridades', scored:true, q:'cuando comienza una nueva semana, ¿cómo se definen normalmente las prioridades?', o:[
      'tenemos prioridades claras y sabemos qué merece atención primero.',
      'existe una planificación, aunque algunas urgencias cambian el foco.',
      'tenemos varios frentes importantes y cuesta decidir cuál atacar primero.',
      'la prioridad normalmente termina siendo el problema más urgente que apareció.']},
    { eje:'decisiones', scored:true, q:'cuando aparece una decisión importante en marketing, stock, caja, equipo u operaciones...', o:[
      'el responsable del área normalmente puede decidir con criterios claros.',
      'algunas decisiones avanzan sin mí y otras necesitan mi participación.',
      'muchas decisiones todavía necesitan mi criterio o aprobación.',
      'prácticamente todo lo importante termina llegando hasta mí.']},
    { eje:'capacidad de crecer', scored:true, q:'si tus ventas aumentaran considerablemente durante los próximos meses, ¿qué pasaría?', o:[
      'la empresa podría absorber bastante bien ese crecimiento.',
      'podríamos absorberlo, aunque algunas áreas necesitarían fortalecerse.',
      'probablemente aparecerían problemas en distintas áreas de la operación.',
      'crecer también aumentaría considerablemente las decisiones y problemas que terminan llegando hasta mí.']},
    { eje:'claridad de palancas', scored:true, q:'¿qué tan claro tienes cuáles son hoy las 3–5 cosas que realmente podrían mover el resultado de tu ecommerce?', o:[
      'muy claro. sabemos cuáles son y por qué.',
      'tenemos buenas hipótesis, pero necesitamos validarlas.',
      'identificamos muchos problemas, pero cuesta saber cuáles realmente mueven la aguja.',
      'tenemos tantos frentes abiertos que las prioridades cambian constantemente.']},
    { eje:'ejecución', scored:true, q:'cuando detectan una prioridad importante, ¿qué suele ocurrir después?', o:[
      'se convierte en una acción concreta, con responsable, criterio y seguimiento.',
      'normalmente avanzamos, aunque no siempre queda completamente sistematizada.',
      'algunas avanzan y otras quedan desplazadas por nuevas urgencias.',
      'muchas veces sabemos qué deberíamos resolver, pero el día a día termina ganando.']}
  ];
  var LETTERS = ['a','b','c','d','e'];

  var RESULTS = {
    verde:{ color:'#7ED957', ink:'#022332', label:'preparar el siguiente nivel',
      h:'tu ecommerce tiene estructura para mirar hacia adelante.',
      p:['tu ecommerce vende, genera resultados y muestra una estructura capaz de sostener buena parte de la operación actual.',
         'no aparecen señales fuertes de que el día a día esté dominando completamente las decisiones.',
         'tu oportunidad parece estar en mirar hacia adelante y detectar qué merece ser fortalecido para seguir creciendo.'],
      c:'¿cuáles son las próximas 3–5 palancas que podrían llevar el negocio a su siguiente nivel?'},
    amarillo:{ color:'#E8B62C', ink:'#022332', label:'priorizar',
      h:'tienes más frentes abiertos que capacidad para atacarlos todos.',
      p:['tu ecommerce está funcionando y genera resultados, pero varios frentes empiezan a competir por atención al mismo tiempo.',
         'probablemente tienes más cosas que podrías mejorar que capacidad para ejecutarlas todas ahora.',
         'tu principal desafío parece estar en separar lo que merece atención ahora, lo que puede esperar y lo que probablemente ni siquiera debería estar entre tus prioridades.'],
      c:'no necesariamente necesitas hacer más. necesitas saber qué mover primero.'},
    naranja:{ color:'#E8762C', ink:'#fff', label:'convertir prioridades en sistemas',
      h:'sabes qué mejorar, pero cuesta que quede resuelto.',
      p:['tu ecommerce ya tiene movimiento y oportunidades claras, pero existe una brecha entre detectar qué debería mejorar y conseguir que eso quede realmente resuelto dentro de la empresa.',
         'algunas prioridades pueden quedar desplazadas por urgencias, falta de responsables, criterios poco claros o decisiones que vuelven constantemente al founder.',
         'tu siguiente paso parece estar en convertir las prioridades correctas en algo concreto: un criterio, un responsable, un proceso, una regla, una automatización o un sistema.'],
      c:'el objetivo no es identificar más problemas. es conseguir que los importantes dejen de repetirse.'},
    rojo:{ color:'#e7392f', ink:'#fff', label:'desconcentrar el negocio',
      h:'demasiado de tu negocio sigue pasando por ti.',
      p:['tu ecommerce está vendiendo, pero existen señales de que demasiadas decisiones, prioridades y excepciones siguen terminando en el founder.',
         'el problema aparece cuando más ventas significan también más decisiones, más aprobaciones y más interrupciones para la misma persona.',
         'tu siguiente palanca puede estar en identificar qué decisiones realmente necesitan tu criterio y cuáles deberían avanzar mediante responsables, criterios y sistemas claros.'],
      c:'el objetivo no es sacarte de tu empresa. es evitar que el crecimiento dependa de que estés en medio de todo.'}
  };

  var state = { screen:'hero', idx:0, answers:[], sel:null, name:'', email:'' };
  var sent = false, poll = null, first = true;

  function esc(s){ return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function validEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e.trim()); }

  function setEnabled(el, on){
    if (!el) return;
    el.disabled = !on;
    el.style.opacity = on ? '1' : '.35';
    el.style.cursor = on ? 'pointer' : 'not-allowed';
  }

  function score(){
    var s = 0;
    for (var i = 1; i < QUESTIONS.length; i++) s += (state.answers[i] || 0) + 1;
    return s;
  }
  function level(s){ return s <= 8 ? 'verde' : s <= 12 ? 'amarillo' : s <= 16 ? 'naranja' : 'rojo'; }

  // ── Pantallas ──
  function renderHero(){
    return '<section class="scr pet hero" aria-label="inicio"><div class="w">'+
      '<div class="hero-top">'+
        '<div class="lbl">ndf growth · diagnóstico de palancas</div>'+
        '<h1 class="h1hero">¿qué está limitando hoy el siguiente tramo de crecimiento de tu ecommerce?</h1>'+
        '<div class="sub">'+
          '<p>tu ecommerce ya está vendiendo y genera resultados. hay equipo, campañas, proveedores, stock, clientes y una operación real funcionando.</p>'+
          '<p>pero cuando una empresa llega a esta etapa, aparece una nueva pregunta: ¿qué deberías resolver ahora para que el negocio pueda seguir creciendo?</p>'+
        '</div>'+
        '<div class="cta-row"><button type="button" class="btn btn-cream" data-action="start">empezar el diagnóstico</button><span class="micro">6 preguntas · 2 minutos</span></div>'+
      '</div>'+
      '<div class="div" role="presentation"></div>'+
      '<div class="how"><div class="lbl">cómo funciona</div><div class="how-g">'+
        '<div class="how-i"><span class="how-n" style="color:#7ED957">01</span><span class="how-t">respondes 6 preguntas sobre cómo funciona hoy tu ecommerce.</span></div>'+
        '<div class="how-i"><span class="how-n" style="color:#E8762C">02</span><span class="how-t">te mostramos dónde podría estar hoy tu principal restricción.</span></div>'+
        '<div class="how-i"><span class="how-n" style="color:#4884a3">03</span><span class="how-t">te decimos cuál puede ser tu siguiente palanca de crecimiento.</span></div>'+
      '</div></div>'+
    '</div></section>';
  }

  function renderAviso(){
    return '<section class="scr pet center aviso"><div class="w">'+
      '<div class="lbl">antes de empezar</div>'+
      '<p class="aviso-t">responde estas preguntas pensando en cómo funciona tu ecommerce hoy.</p>'+
      '<button type="button" class="btn btn-cream" data-action="go">entendido, vamos</button>'+
    '</div></section>';
  }

  function renderQ(){
    var q = QUESTIONS[state.idx], n = QUESTIONS.length, opts = '';
    for (var i = 0; i < q.o.length; i++){
      var on = state.sel === i;
      opts += '<button type="button" role="radio" aria-checked="'+on+'" class="opt'+(on?' on':'')+'" data-action="pick" data-i="'+i+'">'+
        '<span class="lt" aria-hidden="true">'+LETTERS[i]+'</span><span class="ot">'+esc(q.o[i])+'</span></button>';
    }
    return '<section class="scr cream q"><div class="w">'+
      '<div class="q-head"><div class="q-meta"><span class="lbl">pregunta '+(state.idx+1)+' de '+n+'</span><span class="lbl eje">'+esc(q.eje)+'</span></div>'+
        '<div class="bar" role="progressbar" aria-valuemin="1" aria-valuemax="'+n+'" aria-valuenow="'+(state.idx+1)+'"><i style="width:'+((state.idx+1)/n*100)+'%"></i></div></div>'+
      '<h2 class="q-h" id="ndf-dp-q">'+esc(q.q)+'</h2>'+
      '<div class="opts" role="radiogroup" aria-labelledby="ndf-dp-q">'+opts+'</div>'+
      '<div class="q-foot"><button type="button" class="btn btn-pet" data-action="next" data-role="next">siguiente</button>'+
        (state.idx > 0 ? '<button type="button" class="lnk" data-action="back">volver</button>' : '')+'</div>'+
    '</div></section>';
  }

  function renderGate(){
    return '<section class="scr cream center gate"><form class="w" novalidate data-role="gate">'+
      '<div class="lbl">último paso</div>'+
      '<h2 class="gate-h">tu diagnóstico está listo.</h2>'+
      '<p class="gate-p">te mostraremos el diagnóstico en pantalla y también te llegará a tu correo.</p>'+
      '<div class="fields">'+
        '<input class="inp" type="text" name="name" autocomplete="given-name" placeholder="tu nombre" aria-label="tu nombre" value="'+esc(state.name)+'">'+
        '<input class="inp" type="email" name="email" autocomplete="email" inputmode="email" placeholder="tu correo" aria-label="tu correo" value="'+esc(state.email)+'">'+
      '</div>'+
      '<button type="submit" class="btn btn-pet" data-action="submit" data-role="submit">ver mi diagnóstico</button>'+
      '<p class="micro">nada de spam. te escribimos cuando tenemos algo que sirve.</p>'+
    '</form></section>';
  }

  function renderResult(){
    var s = score(), k = level(s), r = RESULTS[k];
    var pct = Math.min(96, Math.max(4, ((20 - s) + 0.5) / 16 * 100));
    var video = SHOW_VIDEO ? '<div class="vid" data-role="vid"><button type="button" class="play" data-action="play" aria-label="reproducir video">'+
      '<svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="#022332"/></svg></button></div>' : '';
    return '<section class="scr cream res"><div class="w">'+
      '<div class="res-top"><div class="lbl">tu resultado</div>'+
        '<span class="pill" style="background:'+r.color+';color:'+r.ink+'">'+esc(r.label)+'</span>'+
        '<h1 class="res-h">'+esc(r.h)+'</h1></div>'+
      '<div class="meter" role="img" aria-label="nivel: '+esc(r.label)+'">'+
        '<svg viewBox="0 0 24 24" style="left:'+pct+'%" aria-hidden="true"><path d="M12 1.5C7.3 1.5 3.6 5.2 3.6 9.9c0 6 8.4 12.6 8.4 12.6s8.4-6.6 8.4-12.6c0-4.7-3.7-8.4-8.4-8.4z" fill="#022332"/><circle cx="12" cy="9.9" r="3.3" fill="#FBF8F3"/></svg>'+
        '<div class="m-bar"><i style="background:#e7392f"></i><i style="background:#E8762C"></i><i style="background:#E8B62C"></i><i style="background:#7ED957"></i></div>'+
        '<div class="m-lb"><span>desconcentrar</span><span>sistematizar</span><span>priorizar</span><span>siguiente nivel</span></div>'+
      '</div>'+
      video+
      '<div class="diag"><div class="lbl">tu diagnóstico</div>'+
        '<p>'+esc(r.p[0])+'</p><p>'+esc(r.p[1])+'</p><p>'+esc(r.p[2])+'</p>'+
        '<p class="cierre">'+esc(r.c)+'</p></div>'+
      '<div class="ctab pet"><div class="lbl">¿y ahora qué?</div>'+
        '<p class="p1">tu resultado muestra dónde podría estar hoy una de las principales restricciones de tu ecommerce. pero no significa que esa sea necesariamente la única.</p>'+
        '<p class="p2">en ndf growth trabajamos durante 60 días sobre la empresa que ya tienes —con tus números, canales, stock, equipo, decisiones y restricciones reales— para identificar entre 3 y 5 palancas clave y trabajar sobre ellas.</p>'+
        '<p class="p3">si quieres descubrir cuáles podrían ser las tuyas:</p>'+
        '<a class="btn btn-cream" href="'+esc(ctaHref(r.label))+'" target="_blank" rel="noopener">quiero agendar mi diagnóstico ndf growth</a></div>'+
      '<button type="button" class="lnk again" data-action="restart">volver a empezar</button>'+
    '</div></section>';
  }

  var RENDER = { hero:renderHero, aviso:renderAviso, q:renderQ, gate:renderGate, result:renderResult };

  function scrollTop(){
    var mt = parseFloat(getComputedStyle(root).scrollMarginTop) || 0;
    var top = root.getBoundingClientRect().top + window.pageYOffset - mt;
    if (Math.abs(window.pageYOffset - top) > 2) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function go(screen){
    state.screen = screen;
    if (poll){ clearInterval(poll); poll = null; }
    root.innerHTML = RENDER[screen]();
    if (screen === 'q') setEnabled(root.querySelector('[data-role="next"]'), state.sel !== null);
    if (screen === 'gate') initGate();
    if (screen === 'result') sendKlaviyo();
    if (!first) scrollTop();
    first = false;
  }

  // ── Gate ──
  function syncGate(){
    var n = root.querySelector('input[name="name"]'), e = root.querySelector('input[name="email"]');
    if (!n || !e) return;
    state.name = n.value; state.email = e.value;
    setEnabled(root.querySelector('[data-role="submit"]'), state.name.trim() !== '' && validEmail(state.email));
  }
  function initGate(){
    var form = root.querySelector('[data-role="gate"]');
    ['input','change'].forEach(function(ev){ form.addEventListener(ev, syncGate); });
    form.addEventListener('submit', function(ev){ ev.preventDefault(); submitGate(); });
    syncGate();
    poll = setInterval(function(){ if (state.screen === 'gate') syncGate(); }, 350);
  }
  function submitGate(){
    syncGate();
    if (!(state.name.trim() && validEmail(state.email))) return;
    state.name = state.name.trim(); state.email = state.email.trim();
    go('result');
  }

  // ── Klaviyo ──
  function sendKlaviyo(){
    if (sent) return;
    sent = true;
    var s = score(), k = level(s), r = RESULTS[k];
    var f = state.answers[0], respuestas = {};
    for (var i = 0; i < QUESTIONS.length; i++) respuestas['p'+(i+1)] = LETTERS[state.answers[i]];
    var fit = (f === 2 || f === 3) ? 'rango principal' : 'revisar';
    var body = { data:{ type:'event', attributes:{
      properties:{
        puntaje:s, puntaje_min:5, puntaje_max:20, nivel:k, nivel_label:r.label,
        resultado_titulo:r.h, resultado_p1:r.p[0], resultado_p2:r.p[1], resultado_p3:r.p[2], resultado_cierre:r.c,
        facturacion: LETTERS[f]+'. '+QUESTIONS[0].o[f], fit_comercial:fit, respuestas:respuestas
      },
      metric:{ data:{ type:'metric', attributes:{ name:'Diagnostico de palancas completado' } } },
      profile:{ data:{ type:'profile', attributes:{ email:state.email, first_name:state.name } } }
    }}};
    try {
      fetch('https://a.klaviyo.com/client/events?company_id='+encodeURIComponent(COMPANY_ID), {
        method:'POST',
        headers:{ 'Content-Type':'application/vnd.api+json', 'Accept':'application/vnd.api+json', 'revision':'2024-10-15' },
        body: JSON.stringify(body)
      }).catch(function(){});
    } catch(e){}
  }

  // ── Click delegado ──
  document.addEventListener('click', function(ev){
    var t = ev.target.closest ? ev.target.closest('[data-action]') : null;
    if (!t || !root.contains(t)) return;
    var a = t.getAttribute('data-action');
    if (t.disabled) return;
    switch (a){
      case 'start': go('aviso'); break;
      case 'go': state.idx = 0; state.sel = state.answers[0] != null ? state.answers[0] : null; go('q'); break;
      case 'pick':
        state.sel = +t.getAttribute('data-i');
        var all = root.querySelectorAll('.opt');
        for (var i = 0; i < all.length; i++){
          var on = i === state.sel;
          all[i].classList.toggle('on', on);
          all[i].setAttribute('aria-checked', on);
        }
        setEnabled(root.querySelector('[data-role="next"]'), true);
        break;
      case 'next':
        if (state.sel === null) return;
        state.answers[state.idx] = state.sel;
        if (state.idx < QUESTIONS.length - 1){
          state.idx++;
          state.sel = state.answers[state.idx] != null ? state.answers[state.idx] : null;
          go('q');
        } else go('gate');
        break;
      case 'back':
        if (state.idx > 0){ state.idx--; state.sel = state.answers[state.idx]; go('q'); }
        break;
      case 'submit': ev.preventDefault(); submitGate(); break;
      case 'play':
        var box = root.querySelector('[data-role="vid"]');
        if (box && VIDEO_URL) box.innerHTML = '<iframe src="'+esc(VIDEO_URL)+'" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="video"></iframe>';
        break;
      case 'restart':
        state = { screen:'hero', idx:0, answers:[], sel:null, name:'', email:'' };
        sent = false;
        go('hero');
        break;
    }
  });

  // Flechas ↑↓ entre opciones
  root.addEventListener('keydown', function(ev){
    if (ev.key !== 'ArrowDown' && ev.key !== 'ArrowUp') return;
    var cur = ev.target.closest && ev.target.closest('.opt');
    if (!cur) return;
    var all = Array.prototype.slice.call(root.querySelectorAll('.opt'));
    var i = all.indexOf(cur) + (ev.key === 'ArrowDown' ? 1 : -1);
    if (all[i]){ ev.preventDefault(); all[i].focus(); }
  });

  go('hero');
})();